/**
 * Client autonome : le serveur local écoute sur un port choisi au lancement de l'exe,
 * le socket temps réel vise donc l'origine courante.
 */
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  if (config.public.standalone !== true) return
  config.public.wsBase = window.location.origin
})
